module.exports = __webpack_public_path__ + "static/img/addTransition.2a890e5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/addTransition.svg
// module id = 01SG
// module chunks = 1